module.exports = __webpack_public_path__ + "media/images/brain1new@2x-ca25593f18df29e2cfa95daad37c78da.png";